import React, { useContext, useEffect, useState } from 'react';

import DeleteCommitmentPopup from './DeleteCommitmentPopup';
import CommitmentQueryContext from '../../../contexts/CommitmentQueryContext';
import usePopup from '../../../hooks/usePopup';
import deleteCommitment from '../../../api/commitments/deleteCommitment';
import CloudFunctionClientContext from '../../../contexts/CloudFunctionClientContext';

const DeleteCommitmentPopupContainer = () => {
  const { api } = useContext(CloudFunctionClientContext);

  // State
  const {
    mode,
    selectedCommitmentDoc,
    setSelectedCommitmentDoc,
    setMode,
    refreshGrid,
  } = useContext(CommitmentQueryContext);
  const { isOpen, open, close } = usePopup();
  const [isSaving, setIsSaving] = useState<boolean>(false);

  // Effects
  useEffect(() => {
    if (!isOpen) {
      if (mode === 'delete') {
        open();
      }
    }
  }, [isOpen, mode, open]);

  // Functions
  const onClose = () => {
    setSelectedCommitmentDoc(undefined);
    setMode('create');
    close();
  };

  const onDeleteConfirmed = () => {
    if (!selectedCommitmentDoc) {
      return;
    }

    setIsSaving(true);
    deleteCommitment(selectedCommitmentDoc, api).then(() => {
      setIsSaving(false);
      refreshGrid();
      onClose();
    });
  };

  return (
    <DeleteCommitmentPopup
      isOpen={isOpen}
      close={onClose}
      onDeleteConfirmed={onDeleteConfirmed}
      isSaving={isSaving}
    />
  );
};

export default DeleteCommitmentPopupContainer;
